import {
  MenuItems,
  SelectInputProps,
  SelectMenu,
  SelectMenuContent,
  SelectMenuItem,
  SelectMenuProvider,
  SelectMenuTriggerType,
} from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

interface SelectInputFieldProps
  extends Omit<SelectInputProps, 'value' | 'onChange'> {
  name: string;
  label?: string;
  options: { label: string; value: string }[];
}

export const SelectInputField = ({
  name,
  label,
  options,
  ...props
}: SelectInputFieldProps) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <div>
      <SelectMenuProvider
        isMultiSelect={true}
        onSelectedChange={onChange}
        selectedItems={value}
      >
        <SelectMenu
          triggerProps={{
            type: SelectMenuTriggerType.MultiSelectInput,
            props: {
              hasClearButton: true,
              decoratorTextProps: {
                ...props.decoratorTextProps,
                description: error?.message,
              },
              placeholder: 'Select',
              hasError: !!error,
              labelProps: {
                label,
                hasInlineLabel: false,
              },
            },
          }}
        >
          <SelectMenuContent>
            <MenuItems>
              {options.map((option) => (
                <SelectMenuItem
                  key={option.value}
                  label={option.label}
                  value={option.value}
                />
              ))}
            </MenuItems>
          </SelectMenuContent>
        </SelectMenu>
      </SelectMenuProvider>
    </div>
  );
};
